/* eslint-disable max-len */
import blackPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/black-pin.png';
import bluePinDown from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/blue-pin-down.png';
import brownPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/brown-pin.png';
import grayPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/gray-pin.png';
import greenPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/green-pin.png';
import orangePin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/orange-pin.png';
import purplePin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/purple-pin.png';
import redPinDown from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/red-pin-down.png';
import whitePin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/white-pin.png';
import yellowPin from '../../../../gaia/static/img/icons/custom_waypoint_icons/preview/yellow-pin.png';

export default {
    'black-pin.png': blackPin,
    'blue-pin-down.png': bluePinDown,
    'brown-pin.png': brownPin,
    'gray-pin.png': grayPin,
    'green-pin.png': greenPin,
    'orange-pin.png': orangePin,
    'purple-pin.png': purplePin,
    'red-pin-down.png': redPinDown,
    'white-pin.png': whitePin,
    'yellow-pin.png': yellowPin,
};
